import React, { Component } from "react";
import { Segment, Grid, List, Header, Label } from "semantic-ui-react";
import fire from '../fire';
import Loading from "../SiteLayout/Loading";
import { Link } from "react-router-dom";

class TafsirSurahMain extends Component {
    constructor(props){
        super(props);
        this.state = {
            isLoading: true
        }
    }

    componentDidMount(){
        const currentSurahNumber = window.location.pathname.split("/")[2];
        const response = fire.firestore().collection("tafsir").doc(currentSurahNumber);
        
        response.get().then((querySnapshot) => {
            this.setState(querySnapshot.data()); 
            this.setState({isLoading: false})     
        });
    }

    render(){
        const currentSurahNumber = window.location.pathname.split("/")[2];
        return(
            this.state.isLoading ?
                <Loading />
            :
                <Grid>
                    <Grid.Row>
                        <Grid.Column>
                            <Segment raised secondary textAlign="center">
                                <Header className="TafsirSurahHeader">
                                    {this.state.surahNameAr}
                                    <Header.Subheader>
                                        {this.state.surahName} ({this.state.surahNameTranslation})
                                    </Header.Subheader>
                                </Header>
                                <Label color="black">
                                    Surah #{this.state.surahNumber}
                                </Label>
                                <Label color="black">
                                    Revealed in {this.state.surahPlaceOfRevelation}
                                </Label>
                                <Label color="black">
                                    {this.state.surahNumberOfAyahs} Ayat Total
                                </Label>
                            </Segment>
                        </Grid.Column>
                    </Grid.Row>
                    <Grid.Row>
                        <Grid.Column>
                            <List divided verticalAlign='middle' relaxed size="large">
                                {
                                    this.state.tafsirs.map(tafsir => (
                                        <List.Item key={tafsir.tafsirNumber} as={Link} to={`/tafsir/${currentSurahNumber}/${tafsir.tafsirNumber}`}>
                                            <Header size="small">
                                                <Label color="red" circular content={tafsir.tafsirNumber} />
                                                {tafsir.tafsirName}
                                            </Header>
                                            
                                        </List.Item>
                                    ))
                                }
                            </List>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>
        );
    }
}
export default TafsirSurahMain;